import React from 'react';
import { StoryBaseEntity } from '../types/entities';

type HomeTemplatesState = {
  items: StoryBaseEntity[] | null;
  loading: boolean;
  error: string | null;
  page: number;
  hasMore: boolean;
  scrollY: number;
  search: string;
};

type HomeTemplatesContextValue = HomeTemplatesState & {
  setState: React.Dispatch<React.SetStateAction<HomeTemplatesState>>;
};

const defaultState: HomeTemplatesState = {
  items: null,
  loading: false,
  error: null,
  page: 1,
  hasMore: true,
  scrollY: 0,
  search: '',
};

const HomeTemplatesContext = React.createContext<HomeTemplatesContextValue | undefined>(undefined);

export const HomeTemplatesProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [state, setState] = React.useState<HomeTemplatesState>(defaultState);

  return (
    <HomeTemplatesContext.Provider value={{ ...state, setState }}>
      {children}
    </HomeTemplatesContext.Provider>
  );
};

export const useHomeTemplates = () => {
  const ctx = React.useContext(HomeTemplatesContext);
  if (!ctx) throw new Error('useHomeTemplates must be used within HomeTemplatesProvider');
  return ctx;
};

export const resetHomeTemplatesState = (setState: React.Dispatch<React.SetStateAction<HomeTemplatesState>>) => {
  setState(() => defaultState);
};

